import { render } from "./techDemands.vue?vue&type=template&id=0ddc737e&scoped=true"
import script from "./techDemands.vue?vue&type=script&lang=js"
export * from "./techDemands.vue?vue&type=script&lang=js"

import "./techDemands.vue?vue&type=style&index=0&id=0ddc737e&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ddc737e"]])

export default __exports__